import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionsLogin } from '../../actions';
import { ComponentsLoginForm } from "../../components/Login/Form";
import { ServiceLogin } from "../../service/Login";
import { Messages } from 'primereact/messages';
import { ServiceMessage } from "../../service/Message";
import { ComponentsAppSplash } from "../../components/App/Splash";
import { HistoricoAceiteLGPD } from '../../service/HistoricoAceiteLGPD';
import { ScreensLGPDForm } from '../LGPD/Form';
import { ServiceApi } from "./../../service/Api";
import { ServiceConfig } from './../../service/Config';

class ScreensLoginMedicoSolicitanteForm extends Component {

    constructor() {

        window.globalVars.acessoMedicoSolicitante = true;

        super();

        this.state = {
            splash: false,
            isLicense: false,
            perfil: "",
            objLGPD: { NomeUsuario: '', Exibir: false }
        };

        this.aceiteLGPD = localStorage.getItem('AceiteLGPD') === 'SIM';
        this.historicoAceiteLGPD = new HistoricoAceiteLGPD();
        this.serviceConfig = new ServiceConfig();
        this.serviceLogin = new ServiceLogin();

        // Acesso via QR Code
        var acesso_qrcode = window.location.hash;
        acesso_qrcode = acesso_qrcode.split("=");
        if (acesso_qrcode[1]) {
            var post = { usuario: acesso_qrcode[1].replace("&pass", ""), senha: acesso_qrcode[2] };
            this.handleExecute(post);
        }

    }

    async handleConfig() {
        const response = await this.serviceConfig.GetConfig();
        if (response) {
            const config = Object.fromEntries(response.map(obj => [obj.Key, obj.Value]));
            const objConfig = {};

            if (config['NOME_BOTAO_IMPRIMIR_PORTAL']) {
                objConfig.NomeBotaoImprimirPortal = config['NOME_BOTAO_IMPRIMIR_PORTAL'];
            }

            if (config['23']) {
                objConfig['23'] = JSON.parse(config['23']);
            }

            sessionStorage.setItem('config', JSON.stringify(objConfig));

            return objConfig;
        }
    }

    async handleLogin(payload, cnpjCliente) {
        try {
            const response = await this.serviceLogin.login(payload.usuario, payload.senha, cnpjCliente)
            if (response) {
                const config = await this.handleConfig();
                const isLicense = config['23'];

                if (this.aceiteLGPD === false) {
                    return this.setState({ objLGPD: { Usuario: this.getDadosUsuario(response), Exibir: true } });
                }

                if (isLicense) {
                    this.setState({ isLicense: isLicense });
                }

                if (!isLicense) {
                    window.location = "#/portal";
                }
            }
        } catch (err) {
            ServiceMessage.warn('Código do médico ou senha inválidos!');
        } finally {
            this.setState({ splash: false });
        };
    }

    handleExecute(e) {

        this.setState({ splash: true });

        ServiceApi._getCnpj().then(cnpjCliente => {

            this.handleLogin(e, cnpjCliente);
        });
    }

    componentDidMount() {
        if (sessionStorage.getItem('auth'))
            this.historicoAceiteLGPD.ChecarAceiteLGPD();
    }

    getDadosUsuario(data) {
        return {
            Nome: data.Nome,
            AcessoDTO: {
                UsuarioId: data.Id,
                Perfil: 'Medico',
                DadosAcesso: ''
            }
        }
    }

    render() {

        return (
            <div>
                <ScreensLGPDForm objLGPD={this.state.objLGPD} />
                <ComponentsAppSplash visible={this.state.splash} />
                <Messages ref={(el) => this.messages = el} />
                <ComponentsLoginForm
                    onExecute={this.handleExecute.bind(this)}
                    exibirTipo={false}
                    isLicense={this.state.isLicense}
                    perfil={this.state.perfil}
                ></ComponentsLoginForm>
            </div>
        );

    }
}

export default (ScreensLoginMedicoSolicitanteForm);